import { HostBinding, Inject, InjectionToken, Input, Directive, Optional } from '@angular/core';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';

// todo: replace by common injection token for edit and view
export const FiDataFieldView_DataField = new InjectionToken('FiDataFieldView_DataField');
export const FiDataFieldView_DataFieldObject = new InjectionToken('FiDataFieldView_DataFieldObject');

@Directive()
export class FiDataFieldViewBase {
    constructor(
        @Inject(FiDataFieldView_DataField) public dataField: DataFieldModel,
        @Inject(FiDataFieldView_DataFieldObject) public dataFieldObject: any,
    ) {}

    @HostBinding('class.fi-data-field-view')
    fiDataFieldViewClass = true;

    @HostBinding('class.fi-data-field-view-not-empty')
    get isNotEmpty() {
        return !!this.dataField.Value;
    }
}
